type PixelType = number | string;

interface PixelToRemInterface {
  (
    top: PixelType,
    right?: PixelType,
    bottom?: PixelType,
    left?: PixelType,
  ): string;
}

const pixelToRem: PixelToRemInterface = (...args) => {
  const oneRem = 16;

  return args.map((parameter) => `${Number(parameter) / oneRem}rem`).join(' ');
};

export default pixelToRem;
